import { Box, type BoxProps, HStack, type StackProps } from '@chakra-ui/react'
import Link from 'next/link'
import { GrandImage } from 'ui'
import { useFooterContext } from '../FooterContext'
import granditudeLogoDark from './granditude_logo_dark.svg'
import granditudeLogoLight from './granditude_logo_light.svg'

type FooterGranditudeSignProps = StackProps & {
  textProps?: BoxProps
}

export const FooterGranditudeSign = ({ textProps, ...props }: FooterGranditudeSignProps) => {
  const { contrastColorTheme } = useFooterContext()

  return (
    <HStack alignItems="center" gap={4} {...props}>
      <Box opacity="0.7" fontSize={['xs', 'sm']} {...textProps}>
        Powered by
      </Box>
      <Link href="https://granditude.com" target="_blank">
        <GrandImage
          maxW="100px"
          src={contrastColorTheme === 'light' ? granditudeLogoLight : granditudeLogoDark}
          alt="Granditude"
          sizes="100px"
        />
      </Link>
    </HStack>
  )
}
